import { camelCase, isArray, isPlainObject, map, reduce } from 'lodash';
import { commonLogger } from './logger/loggerFactory';

type StringKeyed = Record<string, unknown>;

export const guid = () => {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
};

export function objectToCase(fn: (key: string) => string) {
    return (target: unknown): unknown => {
        if (isArray(target)) {
            return map(target, (item: unknown) => objectToCase(fn)(item));
        }

        if (isPlainObject(target)) {
            return reduce(
                target as StringKeyed,
                (acc: StringKeyed, value: unknown, key: string) => {
                    acc[fn(key)] = objectToCase(fn)(value);
                    return acc;
                },
                {} as StringKeyed
            );
        }

        return target;
    };
}

export const objectToCamelCase = (target: unknown) => objectToCase(camelCase)(target);

export const safeStringify = (obj: unknown, space = 2, replacer?: (this: unknown, key: string, value: unknown) => unknown) => {
    try {
        return JSON.stringify(obj, replacer || undefined, space);
    } catch {
        const keys = typeof obj === 'object' && obj ? Object.keys(obj as object) : [];
        const errorMessage = `Failed to stringify obj with keys ${keys}`;
        commonLogger.error(errorMessage);
        return errorMessage;
    }
};
